export class GoogleAnalytics {
  defaults = {
    bankProductId: 'Co-brand Alfa Debit card'
  };

  constructor (options = {}) {
    this.options = {
      ...this.defaults,
      ...options
    }

    global.dataLayer = global.dataLayer || []
    this.dataLayer = global.dataLayer
  }

  trackMainMenuItemClick ({ screenId, linkUrl }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Main UI',
      'eventAction': 'Navigation Menu | link click',
      'eventLabel': `Main menu | ${screenId} | ${linkUrl}`,
      'eventNonInteraction': false
    })
  }

  trackAccrualsHistoryShowMoreButtonClick ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card History page UI',
      'eventAction': 'Сard history | button click',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackAddCardButtonClick ({ screenId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card dashboard UI',
      'eventAction': 'Add Card | button click',
      'eventLabel': screenId,
      'eventNonInteraction': false
    })
  }

  trackCardBindDialogOpen ({ screenId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card dashboard UI',
      'eventAction': 'Add Card | pop-up open',
      'eventLabel': screenId,
      'eventNonInteraction': false
    })
  }

  trackCardBindSuccess ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card dashboard UI',
      'eventAction': 'Add Card | successful added via pop-up',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackCardFormValidationError ({ inputValues, codeSectionLength }) {
    const fieldsWithValidationErrorIds = []

    inputValues.forEach((item, i) => {
      if (item.length < codeSectionLength) {
        fieldsWithValidationErrorIds.push(i + 1)
      }
    })

    this.dataLayer.push({
      'event': 'autoEvent-UI',
      'eventCategory': 'Unified-LP-Reg-Form-UI',
      'eventAction': 'Form element validation error',
      'eventLabel': `validation error | ${fieldsWithValidationErrorIds.join(', ')}`
    })
  }

  trackCardChange ({ screenId, fromCard, toCard }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card History page UI',
      'eventAction': 'Switch card | button click',
      'eventLabel': `${screenId} | ${fromCard.cardType} | ${toCard.cardType}`,
      'eventNonInteraction': false
    })
  }

  trackOrderClick ({ screenId, linkUrl }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card order',
      'eventAction': 'Order card | button click',
      'eventLabel': `${screenId} | ${linkUrl}`,
      'eventNonInteraction': false
    })
  }

  trackSupportButtonClick ({ screenId, linkUrl }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card dashboard UI',
      'eventAction': 'Support | button click',
      'eventLabel': `${screenId} | ${linkUrl}`,
      'eventNonInteraction': false
    })
  }

  trackPromotionLinkClick ({ screenId, linkUrl, promotionId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | additional marketing info UI',
      'eventAction': 'Promotion | link click',
      'eventLabel': `${screenId} | ${promotionId} | ${linkUrl}`,
      'eventNonInteraction': false
    })
  }

  trackAllPromotionLinkClick ({ screenId, linkUrl }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | additional marketing info UI',
      'eventAction': 'All Promotion list | link click',
      'eventLabel': `${screenId} | ${linkUrl}`,
      'eventNonInteraction': false
    })
  }

  trackHoverToPromotionBanner ({ screenId, benefitId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | additional marketing info UI',
      'eventAction': 'Promotion Banner | hover',
      'eventLabel': `${screenId} | ${benefitId}`,
      'eventNonInteraction': true
    })
  }

  trackPromotionFilter ({ filterUrl }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | additional marketing info UI',
      'eventAction': 'Promotion filter | button click',
      'eventLabel': filterUrl,
      'eventNonInteraction': false
    })
  }

  trackCopyCardCode ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card History page UI',
      'eventAction': 'Copy card code | button click',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackDepositButtonClick ({ screenId, game, bankProductId = this.options.bankProductId }) {
    const pageNames = { card_detail: 'History page' }

    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': `Co-Brand Portal | Card ${pageNames[screenId] || screenId} UI`,
      'eventAction': 'Add Cash | button click',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackCardDetailsButtonClick ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card dashboard UI',
      'eventAction': 'Details | button click',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackAdditionalFuturesHistoryPage ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card History page UI',
      'eventAction': 'Additional features list | button click',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackChangeCardGamePopupOpen ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card History page UI',
      'eventAction': 'Change game | pop-up open',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackChangeCardGame ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card History page UI',
      'eventAction': 'Change game | successful changed via pop-up ',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackChangeGameMyCardsPage ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card detail page UI',
      'eventAction': 'Change game | button click',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackAdditionalFuturesDetailPage ({ screenId, game, bankProductId = this.options.bankProductId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card detail page UI',
      'eventAction': 'Additional features list | button click',
      'eventLabel': `${screenId} | ${bankProductId} | ${game}`,
      'eventNonInteraction': false
    })
  }

  trackBindCardConfirm ({ screenId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card linking form UI',
      'eventAction': 'Linking success | button click',
      'eventLabel': screenId,
      'eventNonInteraction': false
    })
  }

  trackBindPageTermsClick ({ screenId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card linking form UI',
      'eventAction': 'Rule confirm | checkbox click',
      'eventLabel': screenId,
      'eventNonInteraction': false
    })
  }

  trackBindPageClickSelectGame ({ screenId }) {
    this.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Co-Brand Portal | Card linking form UI',
      'eventAction': 'Select game | button click',
      'eventLabel': screenId,
      'eventNonInteraction': false
    })
  }

  sendUserAnalytics ({ userID }) {
    const isSpaIdExisted = this.dataLayer.find(item => item.spaID === userID) || null

    if (isSpaIdExisted) {
      return
    }

    this.dataLayer.push({
      'spaID': userID,
      'visitorType': userID ? 'Authorized' : 'Not authorized'
    })
  }
}

export default new GoogleAnalytics()
